import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateOrgAutoSync = (orgId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_ORGANIZATION_AUTO_SYNC' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/orgs/${orgId}/users/auto-sync/manage`,
            payload,
            {
              params: {
                requestId: reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_ORGANIZATION_AUTO_SYNC_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_ORGANIZATION_AUTO_SYNC_FAILED',
              payload: `Failed to update organization auto sync`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_ORGANIZATION_AUTO_SYNC_FAILED',
            payload: `Failed to update organization auto sync`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'UPDATING_ORGANIZATION_AUTO_SYNC_FAILED',
        payload: `Failed to update organization auto sync`,
      });
    }
  };
};

export default updateOrgAutoSync;
